export const http = {
    get: (url, params, responseType) => {
        return axios.get(url, {params, responseType})
    },
    post: (url, data, params, responseType) => {
        return axios.post(url, data, {params, responseType})
    },
    delete: (url, params) => {
        return axios.delete(url, {params})
    }
};